import countries from "components/Global/Editors/Countries/countries";

export default function(value) {
  return countries[value] || "";
}
